import styled from 'styled-components';

import {
  white,
  fontBig,
  spacing,
  baseShadow,
} from '@propellerads/stylevariables';

import {POPUP_SIZE, THEME} from './types';

const StyledPopupWrapper = styled.div`
  position: fixed;
  z-index: 3000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const StyledPopupInner = styled.div`
  display: flex;
  align-items: center;
  min-height: calc(100% - ${spacing * 15 * 2}px);
  margin: ${spacing * 15}px auto;
  padding: 0 ${spacing * 3}px;
  position: relative;
  width: auto;
`;

interface StyledPopupOverlayProps {
    theme: THEME
    isVisible: boolean
}

const StyledPopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: all 0.3s;

  ${(props: StyledPopupOverlayProps) => props.theme === THEME.LIGHT && `
     background: rgba(255,255,255,.9);
  `}
  
  ${(props: StyledPopupOverlayProps) => props.theme === THEME.DARK && `
    background: rgba(0,0,0,.7);
  `}
  
  ${(props: StyledPopupOverlayProps) => props.isVisible && `
    opacity: 1;
  `}
`;

interface StyledPopupProps {
    size: POPUP_SIZE
    isVisible: boolean
}

const StyledPopup = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 320px;
  max-width: 800px;
  border-radius: ${spacing * 2}px;
  background-color: ${white};
  box-shadow: ${baseShadow};
  transition: all 0.3s;
  opacity: 0;
  white-space: normal;
  transform: translateY(20%);
  margin: 0 auto;
  
  'data-popup-visible': true;

  ${(props: StyledPopupProps) => props.size === POPUP_SIZE.SMALL && `
    width: 400px;
  `}
  
 ${(props: StyledPopupProps) => props.size === POPUP_SIZE.MEDIUM && `
    width: 600px;
 `}
 
  ${(props: StyledPopupProps) => props.size === POPUP_SIZE.BIG && `
    width: 800px;
 `}
  
  ${(props: StyledPopupProps) => props.isVisible && `
    opacity: 1;
    transform: translate(0, 0);
  `}
`;

const StyledPopupHeader = styled.div`
  display: flex;
  min-height: 24px;
  position: relative;
  padding: ${spacing * 6}px ${spacing * 6}px ${spacing * 4}px ${spacing * 6}px;
  font-size: ${fontBig}px;
  align-items: center;
  justify-content: space-between;
`;

const StyledPopupHeaderTitle = styled.div`
  flex: 1;
  line-height: 24px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const StyledPopupHeaderCloseButton = styled.div`
  margin-left: ${spacing * 3}px;
  padding: 0;
  height: 24px;
  width: 24px;
  cursor: pointer;
  border: 0;
  outline: 0;
  background: transparent;
`;

const StyledPopupContent = styled.div`
  padding: 0 ${spacing * 6}px ${spacing * 6}px;
  display: flex;
  justify-content: flex-start;
  word-break: break-word;
  line-height: 1.5;
`;

const StyledPopupFooter = styled.div`
  display: flex;
  min-height: 32px;
  line-height: 32px;
  padding: 0 ${spacing * 6}px ${spacing * 6}px ${spacing * 6}px;
  align-items: center;
  justify-content: flex-end;
  box-sizing: content-box;
`;

export {
  StyledPopupWrapper,
  StyledPopupInner,
  StyledPopupOverlay,
  StyledPopup,
  StyledPopupHeader,
  StyledPopupHeaderTitle,
  StyledPopupHeaderCloseButton,
  StyledPopupContent,
  StyledPopupFooter,
};
